const doc = [({"en":({"js":({"merfoto":({"token":({"enter_token":"Enter token", "your_token_was_added_to_your_contact":"The token was added to your contact."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;